import { render } from "./PreschoolScoresContent.vue?vue&type=template&id=30277ab2&scoped=true&ts=true"
import script from "./PreschoolScoresContent.vue?vue&type=script&lang=ts"
export * from "./PreschoolScoresContent.vue?vue&type=script&lang=ts"

import "./PreschoolScoresContent.vue?vue&type=style&index=0&id=30277ab2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30277ab2"]])

export default __exports__